export const apiRoutes = {
  api_r_user_module_saicaReports_home: {
    path: 'm/saica-reports/home/',
  },
  api_r_user_module_saicaReports_initializeReport: {
    path: 'm/saica-reports/initialize-report/',
  },
  api_r_user_module_saicaReports_report: {
    path: 'm/saica-reports/report/',
  },
  api_r_user_module_saicaReports_saveReport: {
    path: 'm/saica-reports/save-report/',
  },
  api_r_user_module_saicaReports_levelUp: {
    path: 'm/saica-reports/level-up/',
  },
  api_r_user_module_saicaReports_removeReport: {
    path: 'm/saica-reports/remove-report/',
  },
  api_r_user_module_saicaReports_updateReport: {
    path: 'm/saica-reports/update-report/',
  },
  api_r_user_module_saicaReports_report_export_xls: {
    path: 'm/saica-reports/report/export/xls/',
  },
  api_r_user_module_saicaReports_report_export_word: {
    path: 'm/saica-reports/report/export/word/',
  },
};
